var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deviceStatus"},[_c('b-container',[(_vm.deviceStatusData.length > 0)?_c('b-row',_vm._l((_vm.deviceStatusData),function(item,key){return _c('b-col',{key:key,attrs:{"cols":"12"}},[_c('div',{staticClass:"process-title"},[_vm._v(_vm._s(item.process))]),_vm._v(" "),_c('div',{staticClass:"device-data"},[_c('b-progress',{attrs:{"max":item.deviceQty,"height":"3rem"}},_vm._l((_vm.deviceStatusData[key].status),function(statusItem,statusKey){return _c('b-progress-bar',{key:statusKey,staticClass:"progress-dec",style:({
                background:
                  statusKey == 'running'
                    ? '#00b152'
                    : statusKey == 'warning'
                    ? '#ff0000'
                    : statusKey == 'queue'
                    ? '#ffc100'
                    : statusKey == 'maintain'
                    ? '#cccdfe'
                    : statusKey == 'shunting'
                    ? '#09b0ff'
                    : statusKey == 'short'
                    ? '#99f98c'
                    : statusKey == 'offline'
                    ? '#cccccc'
                    : '#cccccc',
              }),attrs:{"value":statusItem}},[(_vm.windowInnerWidth >= 992)?_c('div',[_vm._v("\n                "+_vm._s(statusKey == "running"
                    ? "運轉"
                    : statusKey == "warning"
                    ? "異常"
                    : statusKey == "queue"
                    ? "待機"
                    : statusKey == "maintain"
                    ? "維修"
                    : statusKey == "shunting"
                    ? "調車"
                    : statusKey == "short"
                    ? "短寸"
                    : statusKey == "offline"
                    ? "離線"
                    : "離線")+"\n                "+_vm._s(statusItem)+"\n              ")]):_c('div',[_c('div',{staticClass:"status-text"},[_vm._v("\n                  "+_vm._s(statusKey == "running"
                      ? "運轉"
                      : statusKey == "warning"
                      ? "異常"
                      : statusKey == "queue"
                      ? "待機"
                      : statusKey == "maintain"
                      ? "維修"
                      : statusKey == "shunting"
                      ? "調車"
                      : statusKey == "short"
                      ? "短寸"
                      : statusKey == "offline"
                      ? "離線"
                      : "離線")+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"status-text"},[_vm._v("\n                  "+_vm._s(statusItem)+"\n                ")])])])}),1)],1)])}),1):_c('b-row',_vm._l((_vm.deviceStatusDefault),function(item,key){return _c('b-col',{key:key,attrs:{"cols":"12"}},[_c('div',{staticClass:"process-title"},[_vm._v(_vm._s(item.process))]),_vm._v(" "),_c('div',{staticClass:"device-data"},[_c('b-progress',{attrs:{"max":item.deviceQty,"height":"3rem"}},_vm._l((_vm.deviceStatusDefault[key]
                .status),function(statusItem,statusKey){return _c('b-progress-bar',{key:statusKey,style:({
                background:
                  statusKey == 'running'
                    ? '#00b152'
                    : statusKey == 'warning'
                    ? '#ff0000'
                    : statusKey == 'queue'
                    ? '#ffc100'
                    : statusKey == 'maintain'
                    ? '#cccdfe'
                    : statusKey == 'shunting'
                    ? '#09b0ff'
                    : statusKey == 'short'
                    ? '#99f98c'
                    : statusKey == 'offline'
                    ? '#cccccc'
                    : '#cccccc',
                fontSize: '1rem',
              }),attrs:{"value":statusItem}},[_vm._v("\n              "+_vm._s(statusKey == "running"
                  ? "運轉"
                  : statusKey == "warning"
                  ? "異常"
                  : statusKey == "queue"
                  ? "待機"
                  : statusKey == "maintain"
                  ? "維修"
                  : statusKey == "shunting"
                  ? "調車"
                  : statusKey == "short"
                  ? "短寸"
                  : statusKey == "offline"
                  ? "離線"
                  : "離線")+"\n              "+_vm._s(statusItem)+"\n            ")])}),1)],1)])}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43bc321d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/deviceStatus.vue
// module id = null
// module chunks = 